import {QuoteType} from '../../types'
import {formatValues} from '@/features/project-details/helpers/helpers'
import {correctCurrency} from '@/utilities/constants/user'
import {StyledDivider, StyledTextText, StyledTotalFinalPrice, StyledTotalPrice, StyledTotalPriceWrapper} from './style'
import {useTranslation} from 'react-i18next'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface ProductsTotalPriceProps {
    quoteData: QuoteType
    isSimplifiedQuote?: boolean
}

export const ProductsTotalPrice = ({quoteData, isSimplifiedQuote = false}: ProductsTotalPriceProps) => {
    const {t} = useTranslation()

    // Final price
    const finalPriceProducts = Number(quoteData?.productsFinalPrice)
    const finalPriceServices = Number(quoteData?.servicesFinalPrice)

    // VAT
    const vatProducts = Number(quoteData?.productsVatTotal)
    const vatServices = Number(quoteData?.servicesVatTotal)

    // Transport cost
    const transportCost = Number(quoteData?.transportCostValue)
    const transportCostType = quoteData?.transportCostType

    // Extra discount
    const extraDiscount = Number(quoteData?.extraDiscountValue)
    const extraDiscountType = quoteData?.extraDiscountType

    // Extra services discount for products
    const extraDiscountProductsValue =
        extraDiscountType === 'percentage' ? finalPriceProducts * extraDiscount : extraDiscount
    const productsFinalPriceWithExtraDiscount = finalPriceProducts - extraDiscountProductsValue
    const transportCostValue =
        transportCostType === 'percentage' ? productsFinalPriceWithExtraDiscount * transportCost : transportCost
    // const productsFinalPriceWithTransportCostWithDiscount = productsFinalPriceWithExtraDiscount + transportCostValue
    const productsFinalPriceWithVat =
        productsFinalPriceWithExtraDiscount + productsFinalPriceWithExtraDiscount * vatProducts
    const servicesWithTransport = finalPriceServices + transportCostValue
    const servicesFinalPriceWithVat = servicesWithTransport + servicesWithTransport * vatServices

    if (isSimplifiedQuote) {
        return (
            <StyledTotalPriceWrapper justify={'end'} align={'end'} direction={'column'} gap={4}>
                <Flexbox justify={'end'} align={'end'} gap={4}>
                    <StyledTextText>{t('estimation_tab:products_total_price')}</StyledTextText>
                    <StyledTotalPrice>
                        {quoteData.finalPrice ? formatValues(quoteData.finalPrice, 2) : '---'} {correctCurrency}
                    </StyledTotalPrice>
                </Flexbox>
            </StyledTotalPriceWrapper>
        )
    }

    return (
        <StyledTotalPriceWrapper justify={'end'} align={'end'} direction={'column'} gap={4}>
            {/* PRODUCTS */}
            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:products_price_without_vat')}</StyledTextText>
                <StyledTotalPrice>
                    {finalPriceProducts ? formatValues(finalPriceProducts, 2) : '---'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:products_price_discount')}</StyledTextText>
                <StyledTotalPrice>
                    {finalPriceProducts ? formatValues(extraDiscountProductsValue, 2) : '---'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:products_price_with_vat')}</StyledTextText>
                <StyledTotalPrice>
                    {finalPriceProducts ? formatValues(productsFinalPriceWithVat, 2) : '0'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <StyledDivider />
            {/* SERVICES */}
            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:products_price_with_transport_cost')}</StyledTextText>
                <StyledTotalPrice>
                    {transportCostValue ? formatValues(transportCostValue, 2) : '0'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:services_price_without_vat')}</StyledTextText>
                <StyledTotalPrice>
                    {finalPriceServices ? formatValues(servicesWithTransport, 2) : '0'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:services_price_with_vat')}</StyledTextText>
                <StyledTotalPrice>
                    {finalPriceServices ? formatValues(servicesFinalPriceWithVat, 2) : '0'} {correctCurrency}
                </StyledTotalPrice>
            </Flexbox>

            <StyledDivider />

            {/* TOTAL */}
            <Flexbox justify={'end'} align={'end'} gap={4}>
                <StyledTextText>{t('estimation_tab:total_products_and_services_with_vat')}</StyledTextText>
                <StyledTotalFinalPrice>
                    {formatValues(servicesFinalPriceWithVat + productsFinalPriceWithVat, 2)} {correctCurrency}
                </StyledTotalFinalPrice>
            </Flexbox>
        </StyledTotalPriceWrapper>
    )
}
